import './admin-page.css';
import { Header } from '../header/header';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { Link, Outlet, useLocation } from 'react-router';
import { adminSections } from './admin-sections';
type MenuItem = Required<MenuProps>['items'][number];

export const AdminPage = () => {
  const { pathname } = useLocation();
  const selectedSection = adminSections.find((section) => `/admin/${section.path}` === pathname) ?? adminSections[0];

  const items: MenuItem[] = adminSections.map(({ path, label }) => ({
    key: `/admin/${path}`,
    label: <Link to={path}>{label}</Link>,
  }));

  return (
    <>
      <Header />
      <div className="flex-admin-container">
        <nav className="admin-navigation" aria-label="Admin sections">
          <Menu selectedKeys={[`/admin/${selectedSection.path}`]} mode="inline" items={items} />
        </nav>
        <Outlet />
      </div>
    </>
  );
};
